import React, { Component } from 'react';
import './index.css';

class CircleSlowLoader extends Component{
	constructor(props){
		super(props);
		this.state = {
			
		}			
	}
	
	
	render(){
		return(
			<div className="circle-slow-loader">Loading...</div>
		);
	}
	
}
export default CircleSlowLoader;